import React from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { fetchArticle } from '@/api/contentStack';
import FullPageSingleArticle from '@/components/Articles/FullPageSingleArticle';
import * as env from '@/env';
import { allArticles } from '@/utilities/articles';

export default function Article({ spanishArticleProp, englishArticleProp, articles }) {
  const { spanishArticle } = JSON.parse(spanishArticleProp); // see getStaticProps
  const { englishArticle } = JSON.parse(englishArticleProp); // see getStaticProps

  const { locale } = useRouter();

  const article = locale === 'en' && englishArticle ? englishArticle : spanishArticle;

  return (
    <FullPageSingleArticle
      article={article}
      relatedArticles={articles}
    />
  );
};

Article.propTypes = {
  spanishArticleProp: PropTypes.string,
  englishArticleProp: PropTypes.string,
  articles: PropTypes.array,
};

export async function getStaticProps({ params, locale }) {
  const spanishArticle = await fetchArticle(`/${params.article}`, 'es');
  const englishArticle = await fetchArticle(`/${params.article}`, 'en');

  const allArticlesForLocale = allArticles()[locale];
  const articlesForCategory = allArticlesForLocale.filter((article) => article.article_category === params.category);

  const numRelatedArticles = env.CONTENT_STACK_PAGINATE_AFTER;
  const articles = articlesForCategory
    .filter((article) => article.uid !== spanishArticle?.uid && article.uid !== englishArticle?.uid)
    .slice(0, numRelatedArticles);

  return {
    props: {
      // There was a problem serializing the artcles for some reason, so I had to do this nonsense
      spanishArticleProp: JSON.stringify({ spanishArticle }),
      englishArticleProp: JSON.stringify({ englishArticle }),
      articles,
    },
  };
};

export async function getStaticPaths({ locales }) {
  let paths = [];

  for (const locale of locales) {
    const allArticlesForLocale = allArticles()[locale];
    paths = paths.concat(allArticlesForLocale.map((entry) => {
      return ({
        params: {
          category: entry.article_category,
          article: entry.url.substring(1),
        },
        locale: locale,
      });
    }));
  }
  return { paths, fallback: 'blocking' };
};
